import { useState, useEffect } from 'react';
const MAX_TIME_LEFT = 3600; // 1 hour

const CountdownTimer = ({
  initialTimeLeft,
  cb
}: {
  initialTimeLeft: number;
  cb?: () => void;
}) => {
  const [timeLeft, setTimeLeft] = useState(initialTimeLeft > MAX_TIME_LEFT ? MAX_TIME_LEFT : initialTimeLeft);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (timeLeft === 0) {
      cb && cb();
    }
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `00:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <>{formatTime(timeLeft)}</>;
};
export default CountdownTimer;